import $ from 'jquery';

const $body = $('body');
const inBackend = $body.hasClass('neos-backend');


$(function () {

    if (inBackend) return;

    /**
     * Scroll down to first invalid form field
     */
    $('form .is-invalid').first().each(function () {
        const $element = $(this);

        // Scroll to element
        $('html, body').scrollTop($element.offset().top - 120);
    });

    /**
     * Scroll down to form success message
     */
    $('.form-success-message').first().each(function () {
        const $element = $(this);

        // Scroll to element
        $('html, body').scrollTop($element.offset().top - 120);
    });
});

